
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { VideoMarker } from "@common/model";
import { formatSecondsToHour } from "@common/utils/dateFormat";
import debounce from "@common/utils/debounce";
import watermark from "@common/utils/watermark";
declare const HWPlayer: any;

@Component
export default class VideoPlayer extends Vue {
  @Prop()
  defaultControl!: boolean;
  @Prop({ default: "100%" })
  height;
  @Prop({ default: "100%" })
  width;
  @Prop({ default: 0 })
  startPlayTime;
  @Prop({ default: "" })
  videoUrl;
  @Prop()
  service!: Function;
  @Prop()
  query;
  @Prop({ default: true })
  pip;
  @Prop({ default: () => [] })
  markers!: VideoMarker[]; // 进度条打点位置
  @Prop()
  isMarkEdit!: boolean;

  progressTimer: any = null; // 获取播放进度定时器
  videoPlayer: any = null; // 播放器
  videoTotalTime = ""; // 视频总时长
  videoPlayTime = 0; // 视频已播放时长
  isAddBtnToSmall = false; // 是否已经添加画中画
  isPip = false; // 是否或画中画
  isDrag = false; // 是否在拖动
  mousePos = {
    // 拖拽鼠标位置
    x: 0,
    y: 0
  };
  videoPos = {
    // 视频位置位置
    offsetLeft: 0,
    offsetTop: 100
  };
  fileUrlTimer: any = null; // 获取华为云视频连接去抖计时器句柄
  playSrc = ""; // 视频播放地址
  isLoading = false;
  slideTime = 0;
  isSliding = false;
  appended = false;
  currentMark = {
    x: 0,
    y: 0,
    time: 0,
    name: ""
  };
  setVideoTimer: any;

  get currentMarkStyle() {
    const { x, y, name } = this.currentMark;
    return {
      width: "8px",
      height: "8px",
      position: "fixed",
      zIndex: name ? 10000 : -1,
      left: `${x}px`,
      top: `${y}px`
    };
  }
  get propScale() {
    // 屏幕宽高
    return {
      width: this.width,
      height: this.height,
      padding: 0
    };
  }
  get dragStyle() {
    return {
      left: this.videoPos.offsetLeft + "px",
      top: this.videoPos.offsetTop + "px",
      ...this.propScale
    };
  }
  get elMarks() {
    const obj: any = {};
    this.markers.forEach(item => {
      obj[item.time] = "";
    });
    return obj;
  }
  @Watch("videoUrl", { immediate: true })
  initMyVideo(videoUrl) {
    this.playSrc = "";
    this.resetPlayer();
    this.setVideoUrl(videoUrl);
  }

  @Watch("startPlayTime")
  setStartPlayTime(startVideoPlayTime) {
    this.setVideoPlayTime(startVideoPlayTime);
  }

  @Watch("markers")
  onMarksChange(marks) {
    if (marks && marks.length) {
      this.setMarkEmit(0);
    }
  }

  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    (window as any).hwplayerloaded(function() {
      // hw播放器加载完成监听函数
      if (!document.getElementById("markers")) {
        const s = document.createElement("script");
        s.id = "markers";
        s.type = "text/javascript";
        s.src = "/videojs-markers.js";
        document.body.appendChild(s);
      }
      _this.initPlayer();
    });
    const el = document.documentElement || document.body;
    const clientH = el.clientHeight;
    const clientW = el.clientWidth;
    this.videoPos = {
      // 初始化画中画位置
      offsetLeft: clientW - 430,
      offsetTop: clientH - 290
    };
    document.addEventListener("mousemove", this.onDragVideo); // 防止鼠标在超出监听范围后放开
    document.addEventListener("mouseup", this.onMouseup); // 防止鼠标在超出监听范围后放开
    !this.defaultControl && this.setCustomSlider();
  }

  beforeDestroy() {
    clearInterval(this.progressTimer);
    clearTimeout(this.fileUrlTimer);
    clearTimeout(this.setVideoTimer);
    this.videoPlayer && this.videoPlayer.dispose();
    document.removeEventListener("mousemove", this.onDragVideo);
    document.removeEventListener("mouseup", this.onMouseup);
    document.removeEventListener("mouseup", this.onUp.bind(this));
    watermark.clear("my-video");
  }

  /*
        methods
      */

  setCustomSlider() {
    const slider = document.getElementsByClassName("ant-slider")[0];
    // 进度条
    slider.addEventListener("mousedown", this.onDown.bind(this));
    slider.addEventListener("mouseover", debounce(this.onOver.bind(this), 10));
    document.addEventListener("mouseup", this.onUp.bind(this));
  }
  onMarkClick() {
    this.slideTime = this.currentMark.time;
    this.changeTime(this.slideTime);
  }
  // 全新的获取方法
  setVideoUrl(url): void {
    if (this.playSrc != url) {
      this.resetPlayer();
    }
    this.playSrc = url;
    this.setVideo();
  }
  // 初始化倍速、画中画
  resetPlayer() {
    if (this.videoPlayer) {
      this.videoPlayer.pause();
      this.isPip = false;
      // this.videoPlayer.playbackRate(1);
    }
  }
  insertCustomProgress() {
    const videoWrap = document.getElementsByClassName("vjs-control-bar")[0];
    const old = document.getElementsByClassName("vjs-progress-control")[0];
    videoWrap.replaceChild((this.$refs as any).customProgress, old);
    this.appended = true;
  }
  onOver(e) {
    const overMark = e.target.classList.toString().includes("ant-slider-dot");
    if (overMark) {
      const left = e.target.style.left;
      const marks: any = document.getElementsByClassName("ant-slider-dot");
      for (let i = 0; i < marks.length; i++) {
        if (marks[i].style.left == left) {
          const { x, y } = e.target.getBoundingClientRect();
          Object.assign(this.currentMark, this.markers[i], { x, y });
          break;
        }
      }
    }
  }
  onDown() {
    this.isSliding = true;
  }
  onUp() {
    if (this.isSliding) {
      this.changeTime(this.slideTime);
    }
  }
  changeTime(time) {
    this.isSliding = false;
    this.slideTime = time;
    this.$emit("timeChange", time);
    this.setMarkEmit(time);
    this.setVideoPlayTime(time);
  }
  handleSlideTime(time) {
    const [hour, min, sec] = formatSecondsToHour(time * 1000);
    return time > 60 * 60
      ? `${this.formatTime(hour)}:${this.formatTime(min)}:${this.formatTime(
          sec
        )}`
      : `${this.formatTime(min)}:${this.formatTime(sec)}`;
  }

  formatTime(time: number): string {
    // 格式化时间0变为00
    const strTime = String(Math.floor(time));
    return strTime.length === 1 ? "0" + strTime : strTime;
  }
  slideOnTimeUpdate(player) {
    const currentTime = Math.floor(player.currentTime());
    if (this.slideTime === currentTime || this.isSliding) {
      // 防止多次进行相同判断。timeUpdate一秒内会多次调用
      return;
    }
    this.setMarkEmit(currentTime);
    this.slideTime = currentTime;
  }
  setMarkEmit(currentTime) {
    if (this.markers && this.markers.length) {
      const index = this.markers.findIndex(mark => {
        return mark.time == currentTime;
      });
      if (index > -1) {
        this.$emit("markEmit", this.markers[index]);
      }
    }
  }

  setVideo() {
    this.$nextTick(() => {
      if (!this.videoPlayer) {
        this.setVideoTimer = setTimeout(() => {
          this.setVideo();
        }, 2000);
        return;
      }
      if (this.playSrc) {
        this.videoPlayer.src({
          src: this.playSrc,
          type: this.getType(this.playSrc)
        });
      } else {
        // 如果url为空则重置，防止报错
        this.videoPlayer.load(this.playSrc);
      }
    });
  }
  getType(str: string) {
    const index = str.lastIndexOf("?");
    let type;
    const noParamUrl = index === -1 ? str : str.substr(0, index);
    const types = noParamUrl.match(/\.(mp4|m3u8|flv|mpd)/);
    if (types) {
      type = types[1].toLocaleLowerCase();
    } else {
      type = noParamUrl
        .substr(noParamUrl.lastIndexOf(".") + 1)
        .toLocaleLowerCase();
    }
    if (type === "m3u8") {
      return "application/x-mpegURL";
    } else if (type === "mp4") {
      return "video/mp4";
    } else if (type === "flv") {
      return "video/flv";
    } else if (type === "mpd") {
      return "application/dash+xml";
    } else {
      if (noParamUrl.substr(0, 4).toLocaleLowerCase() === "rtmp") {
        return "rtmp/flv";
      }
      return false;
    }
  }

  initPlayer() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    _this.videoPlayer = new HWPlayer(
      "my-video",
      {
        controls: true,
        playbackRates: [0.5, 1, 1.5, 2],
        controlBar: {
          volumePanel: {
            vertical: true,
            inline: false
          }
        }
      },
      function onPlayerReady(this: any) {
        // 添加this参数，避免ts报错
        if (_this.isAddBtnToSmall) {
          return;
        }

        if (_this.pip) {
          // 添加画中画按钮
          const btnToSmall = this.controlBar.addChild("button");
          btnToSmall.addClass("pip-btn");
          btnToSmall.on("click", async () => {
            await _this.toPip(_this.$refs.video);
          });
          _this.isAddBtnToSmall = true;
        }
        // 开始播放后获取播放时间
        this.on("play", () => {
          _this.$emit("play", this);
        });
        this.on("pause", () => {
          _this.$emit("pause", this);
        });
        this.on("error", () => {
          _this.videoTotalTime = "";
          _this.$emit("error");
        });
        this.on("loadedmetadata", () => {
          _this.$emit("ready", this);
        });
        this.on("canplay", () => {
          _this.$emit("canplay");
          _this.getVideoTotalTime();
        });
        this.on("timeupdate", () => {
          // 时间更新
          _this.slideOnTimeUpdate(this);
          _this.$emit("timeupdate", this);
        });
      }
    );
    // 嵌入自定义进度条
    !this.defaultControl && this.insertCustomProgress();
  }

  async toPip(video) {
    // 进入画中画模式
    this.isPip = !this.isPip;
    this.$emit("onPip", this.isPip);
  }

  getTotalTime() {
    // 获取视频总时长
    if (!this.videoTotalTime) {
      this.getVideoTotalTime();
    }
    return this.videoTotalTime;
  }

  getVideoTotalTime() {
    this.videoTotalTime = this.videoPlayer.duration();
  }

  getCurrentTime() {
    // 获取视频已播放时长
    let playTime = 0;
    if (this.videoPlayer && this.videoPlayer.currentTime) {
      playTime = this.videoPlayer.currentTime();
    }
    this.videoPlayTime = playTime;
    return this.videoPlayTime;
  }
  setVideoPlayTime(startVideoPlayTime) {
    // 设置下次播放的初始时长
    this.videoPlayer && this.videoPlayer.currentTime(startVideoPlayTime);
  }

  onMousedown(e: MouseEvent) {
    // 拖动视频
    this.isDrag = true;
    this.mousePos = {
      x: e.clientX,
      y: e.clientY
    };
  }

  onMouseup() {
    this.isDrag = false;
  }

  onDragVideo(e: MouseEvent) {
    if (!this.isDrag) {
      return;
    }
    const videoLeft = this.videoPos.offsetLeft;
    const videoTop = this.videoPos.offsetTop;
    const clientX = e.clientX;
    const clientY = e.clientY;
    const X = clientX - this.mousePos.x; // 鼠标偏移距离
    const Y = clientY - this.mousePos.y; // 鼠标偏移距离

    const left = videoLeft + X;
    const top = videoTop + Y;

    this.videoPos.offsetLeft = left;
    this.videoPos.offsetTop = top;
    this.mousePos.x = clientX;
    this.mousePos.y = clientY;
  }
}
